var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg077Setting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5201 20.48C6.69944 20.7906 7.03141 20.9814 7.3901 20.98H16.6101C16.9688 20.9814 17.3008 20.7906 17.4801 20.48L22.0901 12.48C22.2687 12.1706 22.2687 11.7894 22.0901 11.48L17.4801 3.47999C17.3008 3.16935 16.9688 2.97856 16.6101 2.97999H7.3901C7.03141 2.97856 6.69944 3.16935 6.5201 3.47999L1.9101 11.48C1.73146 11.7894 1.73146 12.1706 1.9101 12.48L6.5201 20.48ZM8.0001 4.99999H16.0001L20.0001 12L16.0001 19H8.0001L4.0001 12L8.0001 4.99999ZM12.0001 16C14.2092 16 16.0001 14.2091 16.0001 12C16.0001 9.79086 14.2092 8 12.0001 8C9.79096 8 8.0001 9.79086 8.0001 12C8.0001 14.2091 9.79096 16 12.0001 16ZM12.0001 10C13.1047 10 14.0001 10.8954 14.0001 12C14.0001 13.1046 13.1047 14 12.0001 14C10.8955 14 10.0001 13.1046 10.0001 12C10.0001 10.8954 10.8955 10 12.0001 10Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg077Setting);
export default __webpack_public_path__ + "static/media/077-setting.e8f346988238b15b23aaa7721eec3486.svg";
export { ForwardRef as ReactComponent };